export default __webpack_public_path__ + "static/media/health-and-wellbeing.9d4588f0.png";